import { UnitOfMeasure, UnitOfMeasureProperties } from '@fusion/units'
import { isValidObject } from '@/helpers/common/validationHelper'
import { MeasurementType, measurementTypesKey } from '@/services/device-measurements'
import type { SensorReadings } from '@/services/device-service/devices'

type GenericValue<T> = number | boolean | string | null | T

// Return the measurement value without accessing the units library
export function getMeasurementValueByName<T>(
  measurements: SensorReadings,
  measurementName: string,
  valueIfNotFound: T
): GenericValue<T> {
  if (isValidObject(measurements)) {
    const measurement = measurements[measurementName]
    return measurement ? measurement.value : valueIfNotFound
  }
  return valueIfNotFound
}

export function getPMRawMeasurementType(measType: MeasurementType): string {
  let pmType = ''
  switch (measType) {
    case MeasurementType.Pm25:
      pmType = measurementTypesKey[MeasurementType.Pm25Raw]
      break
    case MeasurementType.Pm10:
      pmType = measurementTypesKey[MeasurementType.Pm10Raw]
      break
  }
  return pmType
}

export const getReadingUnitLabel = (unit: UnitOfMeasure): string => {
  return UnitOfMeasureProperties[unit]?.code ?? ''
}

export const toMs = (ts: GenericValue<Date>): number | null => {
  if (ts === null) return null
  if (ts instanceof Date) return ts.getTime()
  if (typeof ts === 'number') return ts < 1e12 ? ts * 1000 : ts // handle both epoch seconds and ms
  const ms = Date.parse(ts as string) // ISO/date string
  return Number.isNaN(ms) ? null : ms
}
